<div class="actions-container">
  <ng-casto-button [label]="'need_mapping.no_choice.info'|translate" class="secondary"
                   (click)="selectFridgeConfiguration('')"></ng-casto-button>
</div>
<ul class="inspiration-items">
  @for (fridgeConfiguration of datas.fridgeConfigurations; track fridgeConfiguration) {
    <li
      [class.active]="current.kitchen.fridgeConfigurationRef === fridgeConfiguration.id"
    >
      <figure (click)="selectFridgeConfiguration(fridgeConfiguration.id)">
      <span class="media padding">
        <img
          class="vertical"
          [src]="'assets/img/' + fridgeConfiguration.img"
          [alt]="fridgeConfiguration.titleRef | translate" />
         <span class="title-overlay">
   {{ fridgeConfiguration.titleRef | translate }}
  </span>
        <span class="state">
          <svg class="icon-action-select-thumb" aria-hidden="true">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
          </svg>
        </span>
      </span>
      </figure>
    </li>
  }

</ul>
